import { useLocation } from "react-router-dom";

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function concatParams(params) {
  let result = "";
  const keys = Object.keys(params);
  for (let i = 0; i < keys.length; i++) {
    if (params[keys[i]]) {
      if (result === "") {
        result += "";
      } else {
        result += "&";
      }

      // Every value (in particular the JSON-encoded agenda, which can
      // contain quotes, braces and whatever characters a user types into a
      // card name) must be percent-encoded, or it corrupts the query string
      // it lives in. `query.get(...)` below decodes it back automatically.
      result += `${keys[i]}=${encodeURIComponent(params[keys[i]])}`;
    }
  }
  return result;
}

export function getParam(paramName) {
  const json = CreateParamsJson();
  return json[paramName];
}

export function CreateParamsJson(params) {
  let query = useQuery();
  const paramNames = [
    "meetingtype",
    "meetingid",
    "starttime",
    "endtime",
    "timetoadd",
    "topictoadd",
    "agenda",
    "pausedat",
    "drift",
  ];
  let contentJson = {};
  paramNames.map((param) => {
    if (query && query.get(param)) {
      return (contentJson[param] = query.get(param));
    }
    return null;
  });
  if (params && params.length > 0) {
    params.map((param) => {
      if (param.name && param.value) {
        contentJson[param.name] = param.value;
      }
      return null;
    });
  }
  return contentJson;
}
